
import { Vue, Component } from 'vue-property-decorator'
import { Action, Getter } from 'vuex-class'
import { getPartnerCompanyList } from '@/api/company'
import { getFinanceAuthority } from "@/api/iousServices"
import { getStoreUserNavbarList, TabDto } from '@/api/goodsModule'
import netFail from '@/views/exception/netFail.vue'

@Component({
  components: { netFail }
})
export default class IndustryMall extends Vue {
  @Getter userId!: string
  @Getter info: any // 用户信息
  @Action setRootPath!: (val: string) => void
  @Action setProviderId!: (val: string) => void
  @Action setWhiteStrips!: (val: string) => void
  @Action setTabModules!: (val: Array<TabDto>) => void
  @Getter companyId!: string
  @Getter tabModules!: Array<TabDto>
  showError = false

  created() {
    console.log('***********shopHome')
    this.$log.setLog({
      file: 'industryMall.vue',
      name: 'created方法',
      type: '进入页面'
    })
    this.getPartnerCompanyList()
    this.getWhiteStrips()
    // this.$bridge.callHandler('getMobileSafetyHeight', {}, (height: number) => {
    //   // console.log('getMobileSafetyHeight ***', height)
    //   this.$store.dispatch('setSafetyHeight', height)
    // })
    // 获取原生状态栏高度
    // this.$bridge.callHandler('getStatusBarHeight', {}, (height: any) => {
    //   console.log('getStatusBarHeight ***', height, typeof height)
    //   this.$store.dispatch('setTopSafetyHeight', height ? Number(height) : 0)
    // })
    // const routes = ['/activity', '/mall', '/mallCategory', '/buyMallCar', '/shopMallOrder', '/shelf', '/salesSlip', '/salespromotion', '/salesstatistics']
    // 设置特定页面的状态栏还给H5
    // this.$bridge.callHandler('setStatusBarNative', routes, () => {})
    const params = [
      {
        path: '/shopMallOrder', // 路由地址
        statusBarColor: 'DCE9F9', // 状态栏颜色
        bottomColor: 'FFFFFF' // 底部安全区颜色
      },
      {
        path: '/information',
        statusBarColor: 'DD2525',
        bottomColor: 'FFFFFF'
      },
      {
        path: '/commodity',
        statusBarColor: 'DD2525',
        bottomColor: 'FFFFFF'
      },
      {
        path: '/shop',
        statusBarColor: 'DD2525',
        bottomColor: 'FFFFFF'
      },
      {
        path: '/salesOrderList',
        statusBarColor: 'DD2525',
        bottomColor: 'FFFFFF'
      },
      {
        path: '/purchaseOrderList',
        statusBarColor: 'DD2525',
        bottomColor: 'FFFFFF'
      },
      {
        path: '/customerManage',
        statusBarColor: 'DD2525',
        bottomColor: 'FFFFFF'
      }
    ]
    this.$bridge.callHandler('setWebViewConfiguration', params, (res) => {
    })
  }

    /**
   * 获取金融权限
   */
  getWhiteStrips() {
    this.$log.setLog({
      file: 'industryMall.vue',
      name: 'getWhiteStrips方法',
      type: '函数执行',
      data: {
        companyId: this.info.companyId
      }
    })
    getFinanceAuthority({companyId: this.info.companyId}).then((res) =>{
      const { code, data } = res
      if( code === "000000" ) {
        this.setWhiteStrips(data.whiteStrips)
      }
      this.$log.setLog({
        file: 'industryMall.vue',
        name: 'getWhiteStrips方法',
        type: '函数执行-成功'
      })
    }).catch(err => {
      this.$log.setLog({
        file: 'industryMall.vue',
        name: 'getWhiteStrips方法',
        type: '函数执行-失败',
        data: err
      })
    })
  }

  /**
   * 判断当前账号是否有合作方企业
   */
  async getPartnerCompanyList() {
    // 获取tab模块
    await getStoreUserNavbarList({storeId: this.companyId, isShow: 1}).then(res => {
      this.setTabModules(res.data)
    })
    let params = {
      partnerCompanyId: this.info.partnerCompanyId || 'system'
      // partnerCompanyId:'62f315b5d5e8c81a7d7881e5'
    }
    this.$log.setLog({
      file: 'industryMall.vue',
      name: 'getPartnerCompanyList方法',
      type: '函数执行',
      data: params
    })
    getPartnerCompanyList(params).then((res) => {
      this.$log.setLog({
        file: 'industryMall.vue',
        name: 'getPartnerCompanyList方法',
        type: '函数执行-成功'
      })
      this.showError = false
      if (res.data.companyList.length) {
        // const module = this.tabModules.find(tab => tab.isShow)
        // this.$router.replace({
        //   path: module ? module.route : '/shopMallOrder',
        //   query: {
        //     isHome: 'home'
        //   }
        // })
        this.$router.replace({
          name: 'Workbench'
        })
      } else {
        this.$router.replace({
          name: 'ShopMallOrder',
          query: {
            isHome: 'home'
          }
        })
      }
    }).catch(err => {
      this.showError = true
      this.$log.setLog({
        file: 'industryMall.vue',
        name: 'getPartnerCompanyList方法',
        type: '函数执行-失败',
        data: err
      })
    })
  }

}
